'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _glamorReact = require('glamor-react');

var _colors = require('../styles/colors');

function style() {
  var fill = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors.COLORS.BLUE;
  var backgroundColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'transparent';

  var backgroundStyle = (0, _colors.background)(backgroundColor);

  return (0, _glamorReact.merge)(backgroundStyle, { fill: fill });
}


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Logo/styles.js
// module id = 1605
// module chunks = 0